var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-avatar",staticStyle:{"background-color":"#163845"}},[_c('strong',{staticStyle:{"font-size":"120%","color":"white"}},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }